<template>
<div class="chapter">
<div class="inner_page">
<div class="frontMatter">
<a id="title2"></a><div class="title-frontMatter"><strong class="b">She’s sexy, successful... and PREGNANT!</strong></div>
<div class="p-c-br"><span>Relax and enjoy our fabulous series about <br/>spirited women and gorgeous men, whose <br/>passion results in pregnancies...sometimes <br/>unexpected! Of course, the birth of a baby is <br/>always a joyful event, and we can guarantee that <br/>our characters will become besotted moms and <br/>dads—but what happened in those nine <br/>months before?</span></div>
<div class="p-blanc"><span> <br/></span></div>
<div class="p-c-br"><span>Share the surprises, emotions, dramas and <br/>suspense as our parents-to-be come to terms <br/>with the prospect of bringing a new little life into <br/>the world.... All will discover that the business of <br/>making babies brings with it the most special <br/>love of all...</span></div>
<div class="p-blanc"><span> <br/></span></div>
<div class="p-c-br"><span>Look out next month for our final arrival—<br/>a Christmas baby—in <br/><strong class="b">The Yuletide Child</strong> (#2070) <br/>by Charlotte Lamb</span></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781459252165_fm02.vue?ac0e8da2